// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".best-sellers-content .content-title,.news-content .content-title,.recomends-content .content-title{margin:0}@media (max-width:1023px){.news-shown .news-card-img{padding-top:56.25%}.title-width h3{width:70%}}", ""]);
// Exports
module.exports = exports;
